<script setup>
import { ref, computed } from 'vue'
import { QrcodeStream } from 'vue-qrcode-reader'
import { useDetectDevice } from '@/composables/device'

const { isMobile } = useDetectDevice()

const props = defineProps({
  timeout: {
    type: Number,
    default: 10000,
  },
  formats: {
    type: Array,
    default: () => ['qr_code'],
  },
  style: {
    type: Object,
    default: null,
  },
})

const scanningTimeout = ref(null)

const style = computed(() => {
  return props.style ? props.style : {
    position: isMobile.value ? 'fixed' : 'static',
    top: '5rem',
    bottom: '1rem',
    zIndex: 100,
  }
})

const emit = defineEmits(['close', 'detect', 'timeout', 'error'])

const onLoaded = () => {
  scanningTimeout.value = setTimeout(() => {
    emit('timeout')
  }, props.timeout)
}

const onDetect = (code) => {
  clearTimeout(scanningTimeout.value)
  emit('detect', code)
}

const onScanError = (error) => {
  console.error(error)
  clearTimeout(scanningTimeout.value)
  emit('error', error)
}

</script>
<template>
  <qrcode-stream
    class="qrcode-scanner"
    :style="style"
    :formats="props.formats == [] ? null : props.formats"
    @detect="onDetect"
    @camera-on="onLoaded"
    @error="onScanError"
  />
</template>
<style>
.qrcode-scanner > #qrcode-stream-tracking-layer {
  display: none !important;
}
.qrcode-scanner > div {
  display: none !important;
}

</style>